export const seeHowItWorksLinks = {
  easy_lookup_services:
    'https://api-docs.dojah.io/guides/identity/lookup/individual-lookup',
  easy_onboard_services: 'https://www.youtube.com/watch?v=c3by_CZ-300',
  document_analysis:
    'https://api-docs.dojah.io/guides/identity/document-analysis',
  address_verification_services:
    'https://api-docs.dojah.io/guides/identity/address-verification',
  aml_screening_services: 'https://api-docs.dojah.io/guides/fraud/aml/aml',
  reconciliation:
    'https://reconcilo-docs-dev.dojah.services/guides/general/introduction/intro',
  easy_detect_services:
    'https://api-docs.dojah.io/guides/fraud/easy-detect/introduction',
  credit_check_services:
    'https://api-docs.dojah.io/docs/nigeria/credit-summary#credit-summary',
};
